import { FileText, Plus } from 'lucide-react';
import { useState } from 'react';
import { CreateDocumentModal } from '../components/CreateDocumentModal.js';
import { DocumentCard } from '../components/DocumentCard.js';
import { useDeleteDocument, useDocuments } from '../hooks/useDocuments.js';

export function DocumentsPage() {
  const [showCreate, setShowCreate] = useState(false);
  const { data: documents, isLoading, error } = useDocuments();
  const deleteMutation = useDeleteDocument();

  const handleDelete = async (id: string) => {
    if (!confirm('Supprimer ce document ? Cette action est irréversible.')) return;
    await deleteMutation.mutateAsync(id);
  };

  return (
    <div>
      {/* Page header */}
      <div className="mb-8 flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-slate-900">Documents</h1>
          <p className="mt-1 text-slate-500">
            Matrices stratégiques, registres ISO et plans d'amélioration.
          </p>
        </div>
        <button
          type="button"
          onClick={() => setShowCreate(true)}
          className="flex items-center gap-2 rounded-xl bg-emerald-500 px-4 py-2.5 text-sm font-medium text-white hover:bg-emerald-600 shadow-sm"
        >
          <Plus className="h-4 w-4" />
          Nouveau document
        </button>
      </div>

      {/* Content */}
      {isLoading ? (
        <div className="flex justify-center py-16">
          <span className="relative flex h-10 w-10" aria-hidden="true">
            <span className="absolute inset-0 rounded-full border-[3px] border-slate-200" />
            <span className="absolute inset-0 animate-spin rounded-full border-[3px] border-transparent border-t-emerald-500" />
          </span>
        </div>
      ) : error ? (
        <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          Erreur lors du chargement des documents.
        </div>
      ) : documents && documents.length > 0 ? (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {documents.map((doc) => (
            <DocumentCard key={doc.id} document={doc} onDelete={handleDelete} />
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center gap-4 rounded-2xl border-2 border-dashed border-slate-200 py-20">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100">
            <FileText className="h-7 w-7 text-slate-400" />
          </div>
          <div className="text-center">
            <p className="font-medium text-slate-700">Aucun document</p>
            <p className="mt-0.5 text-sm text-slate-400">
              Créez votre premier document stratégique.
            </p>
          </div>
          <button
            type="button"
            onClick={() => setShowCreate(true)}
            className="flex items-center gap-2 rounded-xl bg-emerald-500 px-4 py-2.5 text-sm font-medium text-white hover:bg-emerald-600"
          >
            <Plus className="h-4 w-4" />
            Créer un document
          </button>
        </div>
      )}

      {showCreate && <CreateDocumentModal onClose={() => setShowCreate(false)} />}
    </div>
  );
}
